//
import { MaterialIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import { StyleSheet, Text } from 'react-native';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import Touchable from '../Generic/Touchable';

type Props = {
  refresh: () => Promise<void>;
};

const ItemAdicionarEndereco: React.FC<Props> = (props) => {
  const { refresh } = props;
  const navigation = useNavigation();
  return (
    <Touchable
      onPress={() => navigation.navigate('NovoEnderecoPage', { refresh })}
      style={styles.card}
    >
      <MaterialIcons name="add" size={50} color={colors.darkGrey} />
      <Text style={styles.text}>Novo endereço</Text>
    </Touchable>
  );
};

const styles = StyleSheet.create({
  card: {
    width: 180,
    borderWidth: 1,
    borderColor: colors.divider,
    borderRadius: 7,
    padding: 5,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    // backgroundColor: '#fff',
    marginRight: 15,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 150
  },
  text: {
    color: colors.darkGrey,
    textAlign: 'center',
    fontSize: TXT_M
  },
  input: {
    marginBottom: 10
  }
});

export default ItemAdicionarEndereco;
